module.exports = {
  oneClick: {
    saveCardCheckboxLabel: 'I\'d like to save this card for future purchases.',
    cardInfoLabel: '{brand} last {lastFour}',
    newCreditCardLabel: 'Use another credit card',
  },
  creditcardButtonMessage: 'Pay with credit card',
  debitcardButtonMessage: 'Pay with debit card',
  externalpayproviderButtonMessage: 'Pay using Fawry',
  banktransferButtonMessage: 'Pay with bank transfer',
  cardNumberLabel: 'Card number',
  methodName: {
    creditcard: 'Credit card',
    debitcard: 'Debit card',
    externalpayprovider: 'Fawry',
    paymob: 'Mobile Wallet',
  },
  info: {
    paymob: {
      payButton: 'Pay With Mobile Wallet',
      phoneNumber: 'After confirming, you will be automatically redirected to your wallet.',
      title: 'Pay easily with your mobile wallet!',
      description: 'You can complete your payment using any mobile wallet authorized by the Central Bank of Egypt — enjoy fast, secure, and convenient transactions directly from your phone.',
    },
  },
};
